/* jscpd:ignore-start */
import { makePaginatedSearch } from "api/makeApiRequestType/makePaginatedSearch";
import { convertEventDatesToJavascriptDates } from "api/utils/convertEventDatesToJavascriptDates";
import { formatDataForGetRequest } from "api/utils/formatDataForGetRequest";
import { ValidationCallback } from "validation/validate";
/* jscpd:ignore-end */

type RawApiOutputRow = {
	id: string;
	dateStartsUTC: string;
	dateEndsJustBeforeUTC: string;
	timezone: string;
	description?: string;
	source: string;
	isExternallyBookedMeeting: boolean;
};

const flagValidationErrorsInRow: ValidationCallback<RawApiOutputRow> = (
	input,
	{ flag, checkField },
	{ uid }
) => {
	checkField("id", { type: "string" });
	checkField("dateStartsUTC", { type: "datestring" });
	checkField("dateEndsJustBeforeUTC", { type: "datestring" });
	checkField("isExternallyBookedMeeting", { type: "boolean" });

	const isOwnMeeting: boolean = !!uid && (!!input.uid && input.uid === uid);

	if (isOwnMeeting) {
		checkField("timezone", { type: "string" });
		checkField("description", { type: "string", isRequired: false });
		checkField("source", { type: "string" });
	}
};

export type OutputRow = Omit<
	RawApiOutputRow,
	"dateStartsUTC" | "dateEndsJustBeforeUTC"
> & {
	dateStartsUTC: Date;
	dateEndsJustBeforeUTC: Date;
};

export const getExternalCommitments = makePaginatedSearch<
	{
		id?: string;
		uid?: string;
		earliestStartDateUTC?: Date;
		mustStartBeforeUTC?: Date;
		mustEndAfterUTC?: Date;
		mustEndBeforeUTC?: Date;
		source?: string;
	},
	RawApiOutputRow,
	OutputRow
>({
	endPoint: "externalCommitments",
	flagValidationErrorsInRow,
	preProcessor: formatDataForGetRequest,
	postProcessor: convertEventDatesToJavascriptDates
});
